import axios from "axios";
import { Button, Input, Spin, Tooltip } from "antd";
import SimpleBar from "simplebar-react";
import { useEffect, useRef, useState, memo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { debounce } from "lodash";
import Capitalize from "chicago-capitalize";
import { LoadingOutlined } from "@ant-design/icons";
import { BsTrash } from "react-icons/bs";
import { MdFileUpload } from 'react-icons/md';
import Reference from "../../../components/Main/CreateDatum/AddReferenceModal/Reference/Reference";
import HyperLinkInput from "../../../components/Common/HyperLinkInput";
import { modalItemView } from "../../../actions/ModalAction";
import { getSmiliarItem, getReferenceItem } from "../../../api/ItemRequest";
import {
  actionUpdateFormSoldBy,
  addProccessCount,
  addFixedCount,
} from "../../../actions/formAction";
import 'simplebar-react/dist/simplebar.min.css';
import { replaceFormTempId } from "../../../actions/formAction";

const INPUT_TOOLTIP = "Should follow Chicago Style";
const PLACEHOLDER = "Business";

function SoldbyCell({
  index,
  rowInd,
  colInd,
  soldbyData,
  validation,
  preCreateValidation,
  createFlag,
  onShowDetail
}) {
  const dispatch = useDispatch();
  const fileInputRef = useRef(null);
  const formDataRef = useRef([]);
  const formData = useSelector((state) => state.formReducer.formData);
  useEffect(() => { formDataRef.current = formData; }, [formData]);
  const { user } = useSelector((state) => state.authReducer.authData);
  const { tempItems } = useSelector((state) => state.tempItemReducer);
  const [cellItem, setCellItem] = useState(null);
  const [fileUploading, setFileUploading] = useState(false);
  const [imageRemove, setImageRemove] = useState(false);
  const [refItem, setRefItem] = useState(null);
  const [options, setOptions] = useState([]);
  const [userInputedSimilar, setUserInputedSimilar] = useState([]);
  const [isError, setIsError] = useState(false);
  const [isImageError, setIsImageError] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const originalTempIdRef = useRef(null);

  useEffect(() => {
    return () => {
        if (isEditing) {
            dispatch({ type: "CELL_EDITING_END" });
        }
    };
  }, [isEditing]);
  

  // useEffect(() => {
  //   if (refItem) {
  //     const length = formData.length;
  //     const slength = formData[length - 1].soldby.length;
  //     formData[length - 1].soldby[slength - 1].filename.original = refItem.image;
  //   }
  // }, [cellItem, refItem]);

  useEffect(() => {
    if (validation === 0) return;
    onValidate();
  }, [validation]);

  // useEffect(() => {
  //   if (rowInd < -1 || colInd < -1) return;
  //   if (isEditing) return;
  //   const tempItem = formData[rowInd].soldby;
  //   if (!tempItem) return;
  //   if (!tempItem[colInd]) return;
  //   setCellItem({
  //     ...tempItem[colInd],
  //   });
  //   if (tempItem[colInd].refId !== "-1") {
  //     doGetReferenceItem(tempItem[colInd].refId);
  //   } else {
  //     setRefItem(null);
  //   }
  // }, []);

  useEffect(() => {
    if (rowInd < -1 || colInd < -1) return;
    if (isEditing) return;
    if (!soldbyData) return;
    setCellItem({ ...soldbyData });
    if (soldbyData.refId !== "-1") {
        doGetReferenceItem(soldbyData.refId);
    } else {
        setRefItem(null);
    }
  }, [soldbyData]);

   useEffect(() => {
      if (!cellItem) return;
      if (cellItem?.refId !== "-1") return;
      if (cellItem?.refString === "" || cellItem?.filename.cloudName === "") return;
      if (isEditing) return;
  
      const existingTemp = Object.values(tempItems).find(
          t => t.itemName === cellItem.refString && t.image === cellItem.filename.cloudName
      );
  
      if (existingTemp) {
          dispatch(actionUpdateFormSoldBy({
              rkey: rowInd,
              ckey: colInd,
              soldby: { ...cellItem, refId: existingTemp._id, isTemp: true }
          }));
          return;
      }
  
      const tempId = `temp_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
      const newTempItem = {
          _id: tempId,
          itemName: cellItem.refString,
          image: cellItem.filename.cloudName,
          column: "soldByCell",
          itemType: 1,
          isTemp: true,
          createdByRow: rowInd,
          createdAt: new Date().toISOString()
      };
  
      dispatch({ type: "CREATE_TEMP_ITEM", item: newTempItem });
      dispatch(actionUpdateFormSoldBy({
          rkey: rowInd,
          ckey: colInd,
          soldby: { ...cellItem, refId: tempId, isTemp: true }
      }));
    }, [cellItem?.refString, cellItem?.filename.cloudName, isEditing]);
  

  useEffect(() => {
    if (preCreateValidation === 0) return;
    if (onValidate() == false) {
      dispatch(addProccessCount());
      return;
    }
    const checkPreCreateValidation = async () => {
      if (!cellItem) return;

      if (cellItem.refId === "-1" || cellItem.refId.includes("reference;") || cellItem?.refId.startsWith("temp_") || cellItem?.isTemp === true) {
        dispatch(addProccessCount());
        return;
      }
      const items = (await getSmiliarItem(cellItem.refString, 1, user._id)).data;
      const filteredItems = items?.filter((item) => item?._id !== refItem?._id);
      const itemIds = filteredItems.map((el) => el._id);
      const setDifference = () => {
        setOptions(filteredItems);
      };
      if (cellItem.refItems.length === 0 && itemIds.length === 0) {
          dispatch(addProccessCount());
          return;
      }
      // if (itemIds.length !== cellItem.refItems.length) setDifference();
      if (itemIds.length !== cellItem?.refItems.length) {
        dispatch(actionUpdateFormSoldBy({
          key: rowInd,
          soldby: { ...cellItem, refItems: itemIds }
        }));
        dispatch(addProccessCount);
        return;
      }
      const sortedArr1 = itemIds.slice().sort();
      const sortedArr2 = cellItem.refItems.slice().sort();
      for (let i = 0; i < sortedArr1.length; i++) {
        if (sortedArr1[i] !== sortedArr2[i]) {
          dispatch(addProccessCount());
          dispatch(addFixedCount());
          setDifference();
          return;
        }
      }
      dispatch(addProccessCount());
    };
    checkPreCreateValidation();
  }, [preCreateValidation]);

  // useEffect(() => {
  //   if (rowInd < -1 || colInd < -1) return;
  //   if (isEditing) return;
  //   const tempItem = formData[rowInd].soldby;
  //   if (!tempItem) return;
  //   if (!tempItem[colInd]) return;
  //   setCellItem({
  //     ...tempItem[colInd],
  //   });
  //   if (tempItem[colInd].refId !== "-1") {
  //     doGetReferenceItem(tempItem[colInd].refId);
  //   } else {
  //     setRefItem(null);
  //   }
  // }, [formData]);

  const onValidate = () => {
    if (!cellItem) return;
    if (cellItem.refString === "") {
      setIsError(true);
      return false;
    }
    if (cellItem.filename.cloudName === "") {
      setIsImageError(true);
      return false;
    }
    const testVal = Capitalize(cellItem.refString);
    if (testVal !== cellItem.refString) {
      setIsError(true);
      return false;
    } else {
      setIsError(false);
    }
    return true;
  };

 const fetchItems = debounce(async (query) => {
     if (query) {
         try {
             const items = await getSmiliarItem(query, 1, user._id);
             const apiResults = items?.data?.filter(item => item?._id !== refItem?._id) || [];
             
             // Merge temp items
             const tempResults = Object.values(tempItems).filter(item =>
                 item.column === "soldByCell" &&
                 item.itemName.toLowerCase().includes(query.toLowerCase())
             );
             
             setOptions([...tempResults, ...apiResults]);
         } catch (error) {
             setOptions([]);
         }
     } else {
         setOptions([]);
     }
   }, 500);

  const doGetReferenceItem = (refId) => {
      if (refId.startsWith("temp_")) {
          const tempItem = tempItems[refId];
          if (tempItem) {
              setRefItem({
                  itemName: tempItem.itemName,
                  itemType: 1,
                  image: tempItem.image,
                  isTemp: true,
                  _id: refId
              });
          }
          return;
      }
      // Handle reference; items
      if (refId.includes("reference;")) {
              const posString = refId.split(";")[1];
              const posAry = posString.split("-");
              const rowData = formDataRef.current[parseInt(posAry[0])];
              let itemInfo = rowData.madeby[posAry[1]] || rowData.soldby[0];
              if (itemInfo.refString === "" && itemInfo.filename.cloudName === "") {
                  setRefItem(null);
                  dispatch(actionUpdateFormSoldBy({
                      rkey: rowInd,
                      ckey: colInd,
                      soldby: {
                          refId: "-1",
                          filename: { original: "", cloudName: "" },
                          refString: "",
                          refItems: [],
                      },
                  }));
              } else {
                  setRefItem({
                      itemName: itemInfo.refString,
                      itemType: "Soldby",
                      image: itemInfo.filename.cloudName,
                      itemReference: refId,
                  });
              }
              return;
          }
      // Real item
      getReferenceItem(refId).then((data) => {
          setRefItem({ ...data.data });
      });
    };

  const doGetUserSimilarItem = (query) => {
    for (let e1 = 0; e1 < formDataRef.current.length; e1++) {
      const tempElement0 = formDataRef.current[e1].soldby;
      const tempElement1 = formDataRef.current[e1].madeby;
      const tempElement = [...tempElement0, ...tempElement1];
      for (let e2 = 0; e2 < tempElement.length; e2++) {
        const temp = tempElement[e2];
        if (temp.refId !== "-1") continue;
        if (e1 === rowInd && e2 === colInd) continue;
        if (temp.refString.indexOf(query) !== -1) {
          setUserInputedSimilar([
            {
              itemName: temp.refString,
              itemFile: temp.filename,
              itemType: 1,
              itemReference: `${e1}-${e2}`,
            },
          ]);
        }
      }
    }
  };
  
  const onBlurInput = (e) => {
    if (e.relatedTarget === null) {
      onDeselect();
    }
  };
  const onDeselect = () => {
    setOptions([]);
    setUserInputedSimilar([]);
  };

  const onChangeItemInfo = (field, val) => {
    setIsError(false);
    setCellItem({
      ...cellItem,
      [field]: val,
    });
    dispatch(
      actionUpdateFormSoldBy({
        rkey: rowInd,
        ckey: colInd,
        soldby: {
          ...cellItem,
          [field]: val,
        },
      })
    );
    if (field === "refString") {
      fetchItems(val);
      doGetUserSimilarItem(val);
    }
  };

  const onRemoveSelectedItem = () => {
    if (isEditing) {
      dispatch({ type: "CELL_EDITING_END" });
      setIsEditing(false)
    }
    setCellItem({
      refId: "-1",
      filename: {
        original: "",
        cloudName: "",
      },
      refString: "",
      refItems: [],
      sourceLink: "",
      sourceText: "",
      sourceDes: "",
      datumId: ''
    });
    dispatch(
      actionUpdateFormSoldBy({
        rkey: rowInd,
        ckey: colInd,
        soldby: {
          refId: "-1",
          filename: {
            original: "",
            cloudName: "",
          },
          refString: "",
          refItems: [],
          sourceLink: "",
          sourceText: "",
          sourceDes: "",
          datumId: ''
        },
      })
    );
  };

  const onRemoveSelectedFile = () => {
    dispatch({ type: "CELL_EDITING_END" });
    setCellItem({
      ...cellItem,
      filename: {
        original: "",
        cloudName: "",
      },
    });
    dispatch(
      actionUpdateFormSoldBy({
        rkey: rowInd,
        ckey: colInd,
        soldby: {
          ...cellItem,
          filename: {
            original: "",
            cloudName: "",
          },
        },
      })
    );
    setImageRemove(false);
  };

   const onSelectOption = (item) => {
       setCellItem({
           ...cellItem,
           refId: item._id,
           isTemp: item.isTemp || false,
           refItems: options.filter(o => !o.isTemp).map(e => e._id)
       });
       dispatch(actionUpdateFormSoldBy({
           rkey: rowInd,
           ckey: colInd,
           soldby: {
               ...cellItem,
               refId: item._id,
               isTemp: item.isTemp || false,
               refItems: options.filter(o => !o.isTemp).map(e => e._id)
           }
       }));
       setRefItem({ ...item });
       setOptions([]);
       setUserInputedSimilar([]);
     };

  const onSelectUserSimilar = (userItem) => {
    setCellItem({
      refId: `reference;${userItem.itemReference}`,
    });
    dispatch(
      actionUpdateFormSoldBy({
        rkey: rowInd,
        ckey: colInd,
        soldby: {
          ...cellItem,
          refId: `reference;${userItem.itemReference}`,
        },
      })
    );
    setOptions([]);
    setUserInputedSimilar([]);
  };

  const onFileChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;
    setFileUploading(true);
    axios
    .get(`${process.env.REACT_APP_API_BASE_URL}/file/getName`, {
      withCredentials: true
      })
      .then(async (res) => {
        const filename = res.data.filename;
        const formData = new FormData();
        formData.append("file", file);
        formData.append("upload_preset", process.env.REACT_APP_IMAGE_UPLOAD_PRESET);
        formData.append("cloud_name", process.env.REACT_APP_MEDIA_UPLOAD_URL);
        formData.append("public_id", process.env.REACT_APP_IMAGE_UPLOAD_PUBLIC + `/${filename}`);
        formData.append("folder", "tempImage");
        try {
          const uploadRetVal = await axios.post(
            `${process.env.REACT_APP_MEDIA_UPLOAD_URL}`,
            formData
          );
          return axios.post(`${process.env.REACT_APP_API_BASE_URL}/file/saveFileInfo`, {
            original: file.name,
            cloudName: uploadRetVal.data.secure_url,
            reference: "Soldby",
          },
          {
            withCredentials: true
          });
        } catch (err) {
          console.error("Error Uploading Image: ", err);
        }
      })
      .then((res) => {
        setFileUploading(false);
        const temp = res.data.cloudName.replace(process.env.REACT_APP_PUBLIC_FOLDER, "");
        setCellItem({
          ...cellItem,
          filename: {
            original: file.name,
            cloudName: temp,
          },
        });
        setIsImageError(false)
        dispatch(
          actionUpdateFormSoldBy({
            rkey: rowInd,
            ckey: colInd,
            soldby: {
              ...cellItem,
              filename: {
                original: file.name,
                cloudName: temp,
              },
            },
          })
        );
      });
  };
  const onDetailView = () => {
    const logDetails = {
      activity: "loaditem",
      category: 'interaction',
      userId: user._id,
      data: {
        userId: user._id,
        username: user.username,
        viewed_userId: refItem._id
      },
      response: null,
      sessionId: localStorage.getItem('sessionId'),
      status: null,
    };
    dispatch(modalItemView(refItem._id, user._id, logDetails))
    onShowDetail(true)
  };
  const truncate = (str, maxlength = 15) => {
    return (str.length > maxlength) ?
      str.slice(0, maxlength - 1) + '…' : str;
  }
  return (
    <div className="relative mt-1">
      {cellItem && cellItem.refId === "-1" && (
        <>
          <Tooltip title={INPUT_TOOLTIP} trigger={"focus"}>
            <Input
              value={cellItem.refString}
              placeholder={PLACEHOLDER}
              className={`${isError === false ? "border border-success" : ""}`}
              status={isError === false ? null : "error"}
              onChange={(e) => onChangeItemInfo("refString", e.target.value)}
              onBlur={(e) => onBlurInput(e)}
            />
          </Tooltip>
          {isEditing && cellItem.refString !== "" && cellItem.filename.cloudName !== "" && (
            <Button
              className="w-full mt-1"
              type="primary"
              style={{ background: '#f59e0b', borderColor: '#f59e0b' }}
              onClick={() => {
                dispatch({ type: "CELL_EDITING_END" });
                setIsEditing(false);
                const oldTempId = originalTempIdRef.current
                
                const tempId = `temp_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
                const newTempItem = {
                  _id: tempId,
                  itemName: cellItem.refString,
                  image: cellItem.filename.cloudName,
                  itemType: 1,
                  column: "soldByCell",
                  isTemp: true,
                  createdByRow: rowInd,
                  createdAt: new Date().toISOString()
                };
                
                dispatch({ 
                  type: "UPDATE_TEMP_ITEM_ID", 
                  oldTempId, 
                  newTempItem 
                });
                
                const updatedCell = { ...cellItem, refId: tempId, isTemp: true };
                setCellItem(updatedCell);
                setRefItem({
                    itemName: cellItem.refString,
                    image: cellItem.filename.cloudName,
                    itemType: 1,
                    isTemp: true,
                    _id: tempId,
                    createdByRow: rowInd
                });
                
                dispatch(actionUpdateFormSoldBy({
                    rkey: rowInd,
                    ckey: colInd,
                    soldby: updatedCell
                }));
                
                dispatch(replaceFormTempId(oldTempId, tempId, "soldByCell"));
                originalTempIdRef.current = null;
              }}
            >
              Save Draft
            </Button>
          )}
          <input
            type="file"
            ref={fileInputRef}
            className="hidden"
            accept="image/*"
            onChange={onFileChange}
          />
          {fileUploading && <Spin indicator={<LoadingOutlined spin />} />}
          {cellItem.filename && cellItem.filename.cloudName !== "" ? (
            <>
              <div className="relative">
                <div
                  className="mt-1 flex items-center gap-2 cursor-pointer"
                  onClick={() => setImageRemove(!imageRemove)}
                >
                  {!fileUploading && (
                    <img
                      className="h-4 w-4"
                      src={process.env.REACT_APP_PUBLIC_FOLDER + cellItem.filename.cloudName}
                    />
                  )}
                  <div>{truncate(cellItem.filename.original)}</div>
                </div>
                <div className={`relation-item-delete ${imageRemove ? "relation-item-show-delete" : ""}`} >
                  <BsTrash size={25} onClick={() => onRemoveSelectedFile()} />
                </div>
              </div>
            </>
          ) : (
            <>
              {!fileUploading && (
                <Button className={`w-full mt-1`} danger={isImageError} onClick={() => fileInputRef.current.click()}>
                  {" "}
                  Upload Image{" "}
                  <MdFileUpload className="ml-2 mt-1" size={20} />
                </Button>
              )}
            </>
          )}
          <HyperLinkInput
            className="mt-1"
            onChange={(e) => onChangeItemInfo("sourceLink", e.target.value)}
            placeholder="Source Link"
            tooltip={"Must be a valid hyperlink"}
            value={cellItem.sourceLink}
            validation={validation}
          />
          <Input
            className="mt-1"
            onChange={(e) => onChangeItemInfo("sourceText", e.target.value)}
            placeholder="Source Text"
            value={cellItem.sourceText}
          />
          <Input
            className="mt-1"
            onChange={(e) => onChangeItemInfo("sourceDes", e.target.value)}
            placeholder="Source Description (Optional)"
            value={cellItem.sourceDes}
          />
        </>
      )}
      {/* Display source inputs if a Reference is selected but a datum has not been selected */}
      {formDataRef.current[rowInd]?.soldby[index] && 
      (formDataRef.current[rowInd]?.soldby[index]?.datumId === "" || formDataRef.current[rowInd]?.soldby[index]?.datumId === null) && 
      cellItem && cellItem.refId !== "-1" && 
      (
        <div className={`w-[270px]`}>
          <Reference
            location="formSelect"
            reference={refItem}
            id={"Soldby"}
            setSelectedReference={() => onRemoveSelectedItem()}
            onViewDatum={() => onDetailView()}
            draft={refItem?.isTemp === true}
            canEdit={refItem?.isTemp === true && tempItems[cellItem.refId]?.createdByRow === rowInd}
            onEdit={() => {
              dispatch({ type: "CELL_EDITING_START" });
                originalTempIdRef.current = cellItem.refId;
                setIsEditing(true)
                setCellItem({
                  ...cellItem,
                  refId: "-1",
                  isTemp: false
                });
                (actionUpdateFormSoldBy({
                  key: rowInd,
                  soldby: {
                    ...cellItem,
                    refId: "-1",
                    isTemp: false
                  }
                }));
                setRefItem(null);
                dispatch({ type: "REMOVE_TEMP_ITEM", tempId: cellItem.refId });
            }}
          />
          <HyperLinkInput
            className="mt-1"
            onChange={(e) => onChangeItemInfo("sourceLink", e.target.value)}
            placeholder="Source Link"
            tooltip={"Must be a valid hyperlink"}
            value={cellItem.sourceLink}
            validation={validation}
          />
          <Input
            className="mt-1"
            onChange={(e) => onChangeItemInfo("sourceText", e.target.value)}
            placeholder="Source Text"
            value={cellItem.sourceText}
          />
          <Input
            className="mt-1"
            onChange={(e) => onChangeItemInfo("sourceDes", e.target.value)}
            placeholder="Source Description (Optional)"
            value={cellItem.sourceDes}
          />
        </div>
      )}
      {/* Display only Reference if a datum has been selected */}
      {formDataRef.current[rowInd]?.soldby[index]?.datumId && formDataRef.current[rowInd]?.soldby[index]?.datumId !== "" && (
        <div className={`w-[270px]`}>
          <Reference
            location="formSelect"
            reference={refItem}
            id={"Soldby"}
            setSelectedReference={() => onRemoveSelectedItem()}
            onViewDatum={() => onDetailView()}
            draft={refItem?.isTemp === true}
          />
        </div>
      )}
      <div className="similarContainer">
        <SimpleBar style={{ maxHeight: 100 }}>
          {userInputedSimilar.length !== 0 && userInputedSimilar[0].itemFile.cloudName !== "" && (
            <div
              className="user-defined-similarContainer"
              onClick={() => onSelectUserSimilar(userInputedSimilar[0])}
            >
              <div className="flex gap-2 items-center">
                <img
                  className="w-4 h-4 bg-contain"
                  src={
                    process.env.REACT_APP_PUBLIC_FOLDER + userInputedSimilar[0].itemFile.cloudName
                  }
                />
                <div>{userInputedSimilar[0].itemName}</div>
              </div>
            </div>
          )}
          {options.length > 0 && options.map((item, index) => (
            <div className="" key={index}>
              {item.isTemp ? (
                <div 
                  className="user-defined-similarContainer flex gap-2 items-center"
                  style={{ borderLeft: '3px dashed #f59e0b', background: '#fffbeb' }}
                  onClick={() => onSelectOption(item)}
                >
                  <img className="w-4 h-4" src={process.env.REACT_APP_PUBLIC_FOLDER + item.image} />
                  <div>{item.itemName}</div>
                  <span style={{ 
                    fontSize: '0.7rem', background: '#f59e0b', 
                    color: 'white', padding: '1px 5px', 
                    borderRadius: '3px', marginLeft: 'auto' 
                    }}>Draft</span>
                </div>
              ) : (
                <Reference
                  location="fromReference"
                  reference={item}
                  id={index}
                  setDisplayReferences={() => onSelectOption(item)}
                  />
              )}
            </div>
          ))}
        </SimpleBar>
      </div>
    </div>
  );
}

export default memo(SoldbyCell, (prevProps, nextProps) => {
  return (
      prevProps.rowInd === nextProps.rowInd &&
      prevProps.colInd === nextProps.colInd &&
      prevProps.soldbyData === nextProps.soldbyData &&
      prevProps.validation === nextProps.validation &&
      prevProps.preCreateValidation === nextProps.preCreateValidation &&
      prevProps.createFlag === nextProps.createFlag
  );
});